import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DOZEN_API_URL, DOZEN_APP_PATH } from '../config';
import RulesPage from './RulesPage';
import { publishLine } from '../utils/dozen';

function DozenRulesContent() {
  const [schedule, setSchedule] = useState(null);

  useEffect(() => {
    axios
      .get(`${DOZEN_API_URL}/schedule`)
      .then((r) => setSchedule(r.data))
      .catch(() => {});
  }, []);

  return (
    <div className="rules-content">
      <section className="rules-section">
        <h2>Как играть</h2>
        <ul>
          <li>{publishLine(schedule)}</li>
          <li>Слова идут по нарастающей: три по 4 буквы, три по 5, три по 6, два по 7 и одно из 8.</li>
          <li>Только существительные.</li>
          <li>Подходит любое слово из этих букв, если оно есть в словаре: у анаграмм засчитываются все варианты.</li>
          <li>Можно нажимать буквы или печатать — как удобнее. При неправильной попытке буквы сбрасываются.</li>
          <li>Количество попыток не ограничено, пока не кончилось время. Перемешать буквы: один раз на слово.</li>
        </ul>
      </section>

      <section className="rules-section rules-section--note">
        <h2>⏱ Когда начинается время</h2>
        <p>
          Секундомер запускается, когда вы нажмёте «Начать», а не в момент публикации.
          Начинайте когда удобно.
        </p>
        <p>Паузы нет: если закрыть страницу, время продолжает идти.</p>
        <p>На каждое слово: 30 секунд.</p>
      </section>

      <section className="rules-section">
        <h2>Очки</h2>
        <ul>
          <li>Сколько целых секунд осталось, столько и очков.</li>
          <li>Не успели: открывается следующее слово, за это 0 очков.</li>
          <li>Угадали все 12: бонус 10 очков.</li>
          <li>В конце очки за все слова суммируются.</li>
        </ul>
      </section>

      <section className="rules-section">
        <h2>Рейтинг</h2>
        <ul>
          <li>Сыграть дюжину можно один раз.</li>
          <li>В таблице лидеров суммируются очки за день / неделю / всё время.</li>
          <li>
            Для простоты очки считаются целыми секундами. Если они совпали, выше тот,
            кто был на доли секунды быстрее.
          </li>
        </ul>
      </section>
    </div>
  );
}

function DozenRules() {
  return (
    <RulesPage gameTitle="Дюжина" playTo={`${DOZEN_APP_PATH}/game`}>
      <DozenRulesContent />
    </RulesPage>
  );
}

export default DozenRules;
